import "./MainPage.css";
import {Box, Grid} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";

import mvw_gesamt from "../images/main_page_bilder/mvw_2019_cropped.jpg";
import img_juka_gesamt from "../images/juka_bilder/0_gruppenbild_vor_altweibermühle.jpg";
import img_mv_kirchenkonzert from "../images/main_page_bilder/kirchenkonzert_mvw.jpeg";
import img_posaune_basteln from "../images/main_page_bilder/posaune_basteln.jpeg";
import img_aktuelles_1 from "../images/aktuelles/herbstkonzert_2026.jpg";

import SectionHeading from "../components/SectionHeading";
import NewsCard from "../components/NewsCard";
import OverviewCard from "../components/OverviewCard";

function MainPage() {
    const navigate = useNavigate();

    const handleScroll = () => {
        const content = document.getElementById("main_page_inner");
        if (content) content.scrollIntoView({behavior: "smooth"});
    };

    const goToJugend = (component) =>
        navigate("/jugend", {state: {scrollToComponent: component ?? null}});
    const goToMusikverein = () => navigate("/musikverein");

    return (
        <div className="main_page_outer">
            <div className="hero">
                <img className="hero_image" src={mvw_gesamt} alt="Musikverein Wissgoldingen"/>
                <div className="scroll_icon_container">
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className="scroll_icon"
                        onClick={handleScroll}
                    />
                </div>
            </div>

            <div id="main_page_inner" className="main_page_inner">
                <Box component="section" sx={{width: '100%'}}>
                    <SectionHeading>Aktuelles</SectionHeading>

                    <NewsCard
                        title="🎶 Herbstkonzert in Wißgoldingen 🍂"
                        image={img_aktuelles_1}
                        imageAlt="Herbstkonzert 2026"
                        imagePosition="left"
                        endDate={new Date(2026, 10, 15)}
                        body="Gemeinsam mit dem TV Wißgoldingen laden wir euch herzlich zu unserem diesjährigen Herbstkonzert ein! Freut euch auf einen abwechslungsreichen Abend voller Musik. 🎺✨ Mit dabei sind die Jugendkapelle des MV Wißgoldingen (Leitung: Stephan Winter), der Akkordeonclub Waldstetten (Leitung: Manuel Fuchs) und der Musikverein Wißgoldingen (Leitung: Ulrich Allgaier). Kommt vorbei, genießt tolle Musik und lasst euch kulinarisch verwöhnen! Wir freuen uns auf euch! 🙌"
                        meta={[
                            {icon: '📅', text: 'Sa, 14.11.2026 | 19:30 Uhr'},
                            {icon: '📍', text: 'Kaiserberghalle Wißgoldingen'},
                            {icon: '🥨', text: 'Ab 18:00 Uhr Bewirtung durch den Turnverein'},
                            {icon: '🎺', text: 'Jugendkapelle, Akkordeonclub Waldstetten & Musikverein'},
                            {icon: '💸', text: 'Eintritt frei!'},
                        ]}
                    />

                </Box>

                <Box component="section" sx={{width: '100%'}}>
                    <SectionHeading>Unser Verein</SectionHeading>

                    <Grid container spacing={3} alignItems="stretch">
                        <Grid item xs={12} md={4} sx={{display: 'flex'}}>
                            <OverviewCard
                                title="Ausbildung"
                                image={img_posaune_basteln}
                                imageAlt="Posaune basteln"
                                body="Bevor unser Nachwuchs in der Jugendkapelle spielen kann, muss natürlich zuerst ein Instrument erlernt werden. Angefangen bei der Blockflöte für die Jüngeren, bis hin zu einem Holz-, Blechblasinstrument oder Schlagzeug wird bei uns im Verein ausgebildet."
                                onClick={() => goToJugend("ausbildung")}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{display: 'flex'}}>
                            <OverviewCard
                                title="Jugendkapelle"
                                image={img_juka_gesamt}
                                imageAlt="Jugendkapelle"
                                body="In unserer Jugendkapelle, dirigiert von Florian Häfele, lernen junge Musiker das gemeinsame Musizieren in Vorbereitung auf die aktive Kapelle. Neben der Probenarbeit und mehreren Auftritten jedes Jahr steht die Kameradschaft sehr weit vorne."
                                onClick={() => goToJugend()}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{display: 'flex'}}>
                            <OverviewCard
                                title="Aktive Kapelle"
                                image={img_mv_kirchenkonzert}
                                imageAlt="Musikverein Kirchenkonzert"
                                body="In der aktiven Kapelle spielen wir neben zwei Konzerten mit anspruchsvoller Blasmusik-Literatur jedes Jahr diverse Auftritte. Dazu gehören unter anderem verschiedene Gartenfeste, kirchliche Auftritte und Besuche von befreundeten Vereinen."
                                onClick={goToMusikverein}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </div>
        </div>
    );
}

export default MainPage;
